import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { DocumentLinkCreated } from '../../documentLink/DocumentLinkCreated'

@InputType()
export class CreatePurchaseOrderDocumentLinkArgs extends ActionArgs {
  @Field(() => ID)
  purchaseOrderId: string
}

export interface ICreatePurchaseOrderDocumentLink extends IAction<
  DocumentLinkCreated,
  CreatePurchaseOrderDocumentLinkArgs
> {}
